import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

export const FILE_IN_PROGRESS_COLUMNS = [
  {
    Header: "Numéro client",
    accessor: "project.client.reference",
  },
  {
    Header: "Nom client",
    accessor: "project.client.lastname",
    Cell: (cellInfo) => {
      return (
        <Link to={`/client/${cellInfo.row.original.project.client.id}`}>
          {cellInfo.row.original.project.client.firstname}{" "}
          {cellInfo.row.original.project.client.lastname}
        </Link>
      );
    },
  },
  {
    Header: "Typologie projet",
    accessor: "project.type",
  },
  {
    Header: "Date devis",
    accessor: "sentAt",
    Cell: (cellInfo) => {
      let date = new Date(cellInfo.row.original.sentAt);
      if (!date) {
        return "N/A";
      }
      return moment(date).format("DD/MM/YYYY");
    },
  },
  {
		Header: "Documents",
		accessor: "chatbotDocuments",
		Cell: cellInfo => {
			return cellInfo.row.original.chatbotDocuments === true ? <img src={"/images/pictos/fichier.svg"} alt={"Documents transmis"} title={"Documents transmis"} style={{width: "45px", height: "45px"}} /> : "N/A";
		}
	},
  {
    Header: "Gestionnaire projet",
    accessor: "project.arch",
    Cell: cellInfo => {
      const arch = cellInfo.row.original.project.arch ? true : false;
      return arch ? (
        <img style={{width: "45px", height: "45px"}} src={"/images/pictos/responsable.svg"} alt={"Gestionnaire projet"} title={"Gestionnaire projet"} />
      ) : (
        <span>N/A</span>
      )
    }
  },
  {
    Header: "Commercial affilié",
    accessor: "project.com.lastname",
  },
  {
    Header: "Montant devis (HT)",
    accessor: "total",
    Cell: (cellInfo) => {
      let total = 0;
      if (cellInfo.row.original.total) {
        total = cellInfo.row.original.total.toFixed(2) + " €";
      } else {
        total = "0.00 €";
      }
      return total;
    },
  },
  {
    Header: "Statut projet",
    accessor: "firstNotifiedAt",
    Cell: (cellInfo) => {
      const firstNotifiedAt = cellInfo.row.original.firstNotifiedAt;

      if (!firstNotifiedAt) {
        return (
          <div className="badge badge-waiting">
            <div className={"pin-wainting"}></div>
            En cours
          </div>
        );
      }

      const notifiedDate = moment(firstNotifiedAt);

      if (!notifiedDate.isValid()) {
        return (
          <div className="badge badge-waiting">
            <div className={"pin-wainting"}></div>
            En cours
          </div>
        );
      }

      const daysSinceFirstNotified = moment().diff(notifiedDate, "days");

      if (daysSinceFirstNotified >= 23) {
        return (
          <div className="badge badge-archive">
            <div className={"pin-archive"}></div>
            A archiver
          </div>
        );
      }

      if (daysSinceFirstNotified >= 7) {
        return (
          <div className="badge badge-error">
            <div className={"pin-error"}></div>
            A relancer J+14
          </div>
        );
      }

      return (
        <div className="badge badge-error">
          <div className={"pin-error"}></div>
          A relancer J+7
        </div>
      );
    },
  },
  {
    Header: "",
    accessor: "details",
    Cell: (cellInfo) => {
      return (
        <Link className="btn-little btn-default-primary color-primary" to={`/projet/${cellInfo.row.original.project.id}`}>
          Accéder aux documents
        </Link>
      );
    },
  },
];
